import React from "react";
import { Card, Alert } from "react-bootstrap";

function CreatingSchedules() {
  return (
    <div>
      <h2 className="mb-4">Creating Schedules</h2>

      <Alert variant="info">
        Learn how to create automated schedules to run your runbooks at specific times or intervals.
      </Alert>

      <Card className="mb-4">
        <Card.Body>
          <h4>Creating a New Schedule</h4>
          <ol>
            <li>Go to <strong>My Schedulers</strong></li>
            <li>Click the <strong>Add Schedule</strong> button</li>
            <li>Fill in the scheduler details:
              <ul className="mt-2">
                <li><strong>Runbook</strong> - Select which runbook to execute</li>
                <li><strong>Cron Expression</strong> - Define when to run (see below)</li>
                <li><strong>Timezone</strong> - Select the appropriate timezone</li>
              </ul>
            </li>
            <li>Click <strong>Save</strong></li>
            <li>The schedule will become active immediately</li>
          </ol>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Using the Cron Expression Builder</h4>
          <p>
            The portal provides a visual cron expression editor that makes it easy to create schedules without
            learning cron syntax:
          </p>
          <ol>
            <li>In the scheduler form, you'll see a cron expression builder</li>
            <li>Use the dropdown menus and inputs to configure:
              <ul className="mt-2">
                <li>Minutes</li>
                <li>Hours</li>
                <li>Day of month</li>
                <li>Month</li>
                <li>Day of week</li>
              </ul>
            </li>
            <li>As you make selections, a human-readable translation appears below</li>
            <li>For example: "At 09:00 AM, only on Monday"</li>
          </ol>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Common Schedule Patterns</h4>
          <p>Here are some common scheduling scenarios:</p>

          <h6 className="mt-3">Daily Execution</h6>
          <p>To run every day at a specific time, set the hour and minute, and use "*" for all other fields.</p>

          <h6 className="mt-3">Weekly Execution</h6>
          <p>To run on specific days of the week, select those days in the "Day of week" field.</p>

          <h6 className="mt-3">Monthly Execution</h6>
          <p>To run on a specific day of the month, set the "Day of month" field.</p>

          <h6 className="mt-3">Hourly Execution</h6>
          <p>To run every hour, set the minute and use "*" for the hour field.</p>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Editing a Schedule</h4>
          <ol>
            <li>Go to <strong>My Schedulers</strong></li>
            <li>Select the schedule you want to edit</li>
            <li>Click the <strong>Edit</strong> button</li>
            <li>Make your changes</li>
            <li>Click <strong>Save</strong></li>
          </ol>
          <p className="mt-3">
            <em>Note: Changes take effect immediately. The next execution will use the new schedule.</em>
          </p>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Deleting a Schedule</h4>
          <ol>
            <li>Go to <strong>My Schedulers</strong></li>
            <li>Select the schedule you want to delete</li>
            <li>Click the <strong>Delete</strong> button</li>
            <li>Confirm the deletion</li>
          </ol>
          <p className="mt-3">
            <em>Note: Deleting a schedule does not delete the runbook itself. It only removes the automated execution schedule.</em>
          </p>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Troubleshooting</h4>
          <p>If you see a "cron error" status on a scheduler:</p>
          <ul>
            <li>The cron expression may be invalid</li>
            <li>Edit the schedule and fix the cron expression</li>
            <li>Make sure all required fields have valid values</li>
            <li>Check the human-readable translation to ensure it matches your intent</li>
          </ul>
        </Card.Body>
      </Card>
    </div>
  );
}

export default CreatingSchedules;
